import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const PasswordPage = () => {
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/auth/update-password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email,
            oldPassword: "", // Not required for reset in your case
            newPassword,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
      } else {
        setError(data.message || "Password reset failed");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
      console.error(err);
    }
  };

  return (
    <div className="welcome_page">
      <div className="sidebar">
        <img
          src="sidebar_avatar.png"
          alt="Sidebar Avatar"
          className="sidebar_avatar"
        />
        <img
          src="church_logo_no_bg.png"
          alt="Church Logo"
          className="church_logo"
        />
      </div>

      <div className="form_side">
        <button
          onClick={() => navigate("/")}
          className="mb-4 text-blue-600 hover:underline"
        >
          ← Return to Login
        </button>
        <div className="form_main">
          <div className="form_head">
            <h1>Reset Password</h1>
            <p>Use your registered email</p>
          </div>

          <div className="form_body">
            <form onSubmit={handleResetPassword}>
              <div className="form_body1">
                <label htmlFor="email">EMAIL ADDRESS</label>
                <input
                  type="email"
                  placeholder="johndoe@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="form_body1 form_pass">
                <label htmlFor="newPassword">NEW PASSWORD</label>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="************"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
              </div>

              <div className="form_body1 form_pass">
                <label htmlFor="confirmPassword">CONFIRM PASSWORD</label>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="************"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="form_toggle_btn"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "🙈" : "👁️"}
                </button>
              </div>

              {error && (
                <p style={{ color: "red", fontSize: "small" }}>{error}</p>
              )}

              {success && (
                <p style={{ color: "green", fontSize: "small" }}>
                  ✅ Password reset!{" "}
                  <span
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => navigate("/")}
                  >
                    Click here to login
                  </span>
                </p>
              )}

              <button className="form_login_btn" type="submit">
                RESET PASSWORD
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordPage;
